// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Sources:
//   business/ishvaram/data/domain/astrology/nakshatras.yaml (base fields)
//   business/ishvaram/data/domain/astrology/matching.yaml (nadi map)
//   business/ishvaram/data/domain/astrology/baby_names.yaml (pada letters)

export type NakshatraId =
  | "ashwini"
  | "bharani"
  | "krittika"
  | "rohini"
  | "mrigashira"
  | "ardra"
  | "punarvasu"
  | "pushya"
  | "ashlesha"
  | "magha"
  | "purva_phalguni"
  | "uttara_phalguni"
  | "hasta"
  | "chitra"
  | "swati"
  | "vishakha"
  | "anuradha"
  | "jyeshtha"
  | "moola"
  | "purva_ashadha"
  | "uttara_ashadha"
  | "shravana"
  | "dhanishta"
  | "shatabhisha"
  | "purva_bhadrapada"
  | "uttara_bhadrapada"
  | "revati";

export interface Nakshatra {
  /** Vedic id, e.g. "ashwini" */
  id: NakshatraId;
  name_en: string;
  name_hi: string;
  /** 1-27 */
  number: number;
  degree_start: number;
  degree_end: number;
  /** rashi id this nakshatra falls in */
  rashi: string;
  /** ruling planet id */
  ruler: string;
  deity: string;
  symbol: string;
  /** deva | manushya | rakshasa */
  nature: string;
  /** deva | manushya | rakshasa */
  gana: string;
  quality: string;
  signifies: string[];
  padas?: readonly {
    pada: number;
    syllable_en: string;
    syllable_hi?: string;
    navamsha_rashi?: string;
    sub_ruler?: string;
  }[];
  /** adi | madhya | antya — used in Ashtakoota Nadi koota */
  nadi: string;
  /** All 4 pada starting letters (e.g. ["Chu","Che","Cho","La"]) */
  letters: string[];
  /** Same as letters; kept for API compat with consumers expecting per-pada array */
  pada_letters: string[];
}

export const nakshatras: readonly Nakshatra[] = [
  {
    id: "ashwini",
    name_en: "Ashwini",
    name_hi: "अश्विनी",
    number: 1,
    degree_start: 0,
    degree_end: 13.333,
    rashi: "mesh",
    ruler: "ketu",
    deity: "Ashwini Kumaras",
    symbol: "Horse head",
    nature: "deva",
    gana: "deva",
    quality: "swift",
    signifies: ["healing", "speed", "beginnings", "medicine"],
    padas: [
      {
        pada: 1,
        syllable_en: "Chu",
        syllable_hi: "चु",
        navamsha_rashi: "Mesh",
        sub_ruler: "Mars",
      },
      {
        pada: 2,
        syllable_en: "Che",
        syllable_hi: "चे",
        navamsha_rashi: "Vrishabh",
        sub_ruler: "Venus",
      },
      {
        pada: 3,
        syllable_en: "Cho",
        syllable_hi: "चो",
        navamsha_rashi: "Mithun",
        sub_ruler: "Mercury",
      },
      {
        pada: 4,
        syllable_en: "La",
        syllable_hi: "ला",
        navamsha_rashi: "Karka",
        sub_ruler: "Moon",
      },
    ],
    nadi: "adi",
    letters: ["Chu", "Che", "Cho", "La"],
    pada_letters: ["Chu", "Che", "Cho", "La"],
  },
  {
    id: "bharani",
    name_en: "Bharani",
    name_hi: "भरणी",
    number: 2,
    degree_start: 13.333,
    degree_end: 26.667,
    rashi: "mesh",
    ruler: "venus",
    deity: "Yama",
    symbol: "Yoni (female organ)",
    nature: "manushya",
    gana: "manushya",
    quality: "fierce",
    signifies: ["restraint", "transformation", "death_rebirth", "fertility"],
    padas: [
      {
        pada: 1,
        syllable_en: "Li",
        syllable_hi: "ली",
        navamsha_rashi: "Simha",
        sub_ruler: "Sun",
      },
      {
        pada: 2,
        syllable_en: "Lu",
        syllable_hi: "लू",
        navamsha_rashi: "Kanya",
        sub_ruler: "Mercury",
      },
      {
        pada: 3,
        syllable_en: "Le",
        syllable_hi: "ले",
        navamsha_rashi: "Tula",
        sub_ruler: "Venus",
      },
      {
        pada: 4,
        syllable_en: "Lo",
        syllable_hi: "लो",
        navamsha_rashi: "Vrishchik",
        sub_ruler: "Mars",
      },
    ],
    nadi: "madhya",
    letters: ["Li", "Lu", "Le", "Lo"],
    pada_letters: ["Li", "Lu", "Le", "Lo"],
  },
  {
    id: "krittika",
    name_en: "Krittika",
    name_hi: "कृत्तिका",
    number: 3,
    degree_start: 26.667,
    degree_end: 40,
    rashi: "mesh",
    ruler: "sun",
    deity: "Agni",
    symbol: "Razor/flame",
    nature: "rakshasa",
    gana: "rakshasa",
    quality: "mixed",
    signifies: ["purification", "fire", "cutting", "nourishment"],
    padas: [
      {
        pada: 1,
        syllable_en: "A",
        syllable_hi: "अ",
        navamsha_rashi: "Dhanu",
        sub_ruler: "Jupiter",
      },
      {
        pada: 2,
        syllable_en: "I",
        syllable_hi: "ई",
        navamsha_rashi: "Makar",
        sub_ruler: "Saturn",
      },
      {
        pada: 3,
        syllable_en: "U",
        syllable_hi: "उ",
        navamsha_rashi: "Kumbh",
        sub_ruler: "Saturn",
      },
      {
        pada: 4,
        syllable_en: "E",
        syllable_hi: "ए",
        navamsha_rashi: "Meen",
        sub_ruler: "Jupiter",
      },
    ],
    nadi: "antya",
    letters: ["A", "I", "U", "E"],
    pada_letters: ["A", "I", "U", "E"],
  },
  {
    id: "rohini",
    name_en: "Rohini",
    name_hi: "रोहिणी",
    number: 4,
    degree_start: 40,
    degree_end: 53.333,
    rashi: "vrishabh",
    ruler: "moon",
    deity: "Brahma",
    symbol: "Chariot/ox cart",
    nature: "manushya",
    gana: "manushya",
    quality: "fixed",
    signifies: ["growth", "beauty", "creation", "fertility", "desire"],
    padas: [
      {
        pada: 1,
        syllable_en: "O",
        syllable_hi: "ओ",
        navamsha_rashi: "Mesh",
        sub_ruler: "Mars",
      },
      {
        pada: 2,
        syllable_en: "Va",
        syllable_hi: "वा",
        navamsha_rashi: "Vrishabh",
        sub_ruler: "Venus",
      },
      {
        pada: 3,
        syllable_en: "Vi",
        syllable_hi: "वी",
        navamsha_rashi: "Mithun",
        sub_ruler: "Mercury",
      },
      {
        pada: 4,
        syllable_en: "Vu",
        syllable_hi: "वू",
        navamsha_rashi: "Karka",
        sub_ruler: "Moon",
      },
    ],
    nadi: "antya",
    letters: ["O", "Va", "Vi", "Vu"],
    pada_letters: ["O", "Va", "Vi", "Vu"],
  },
  {
    id: "mrigashira",
    name_en: "Mrigashira",
    name_hi: "मृगशिरा",
    number: 5,
    degree_start: 53.333,
    degree_end: 66.667,
    rashi: "vrishabh",
    ruler: "mars",
    deity: "Soma/Chandra",
    symbol: "Deer head",
    nature: "deva",
    gana: "deva",
    quality: "soft",
    signifies: ["searching", "curiosity", "travel", "beauty"],
    padas: [
      {
        pada: 1,
        syllable_en: "Ve",
        syllable_hi: "वे",
        navamsha_rashi: "Simha",
        sub_ruler: "Sun",
      },
      {
        pada: 2,
        syllable_en: "Vo",
        syllable_hi: "वो",
        navamsha_rashi: "Kanya",
        sub_ruler: "Mercury",
      },
      {
        pada: 3,
        syllable_en: "Ka",
        syllable_hi: "का",
        navamsha_rashi: "Tula",
        sub_ruler: "Venus",
      },
      {
        pada: 4,
        syllable_en: "Ki",
        syllable_hi: "की",
        navamsha_rashi: "Vrishchik",
        sub_ruler: "Mars",
      },
    ],
    nadi: "madhya",
    letters: ["Ve", "Vo", "Ka", "Ki"],
    pada_letters: ["Ve", "Vo", "Ka", "Ki"],
  },
  {
    id: "ardra",
    name_en: "Ardra",
    name_hi: "आर्द्रा",
    number: 6,
    degree_start: 66.667,
    degree_end: 80,
    rashi: "mithun",
    ruler: "rahu",
    deity: "Rudra",
    symbol: "Teardrop/diamond",
    nature: "manushya",
    gana: "manushya",
    quality: "sharp",
    signifies: ["storms", "destruction_renewal", "effort", "transformation"],
    padas: [
      {
        pada: 1,
        syllable_en: "Ku",
        syllable_hi: "कू",
        navamsha_rashi: "Dhanu",
        sub_ruler: "Jupiter",
      },
      {
        pada: 2,
        syllable_en: "Gha",
        syllable_hi: "घ",
        navamsha_rashi: "Makar",
        sub_ruler: "Saturn",
      },
      {
        pada: 3,
        syllable_en: "Nga",
        syllable_hi: "ङ",
        navamsha_rashi: "Kumbh",
        sub_ruler: "Saturn",
      },
      {
        pada: 4,
        syllable_en: "Chha",
        syllable_hi: "छ",
        navamsha_rashi: "Meen",
        sub_ruler: "Jupiter",
      },
    ],
    nadi: "adi",
    letters: ["Ku", "Gha", "Nga", "Chha"],
    pada_letters: ["Ku", "Gha", "Nga", "Chha"],
  },
  {
    id: "punarvasu",
    name_en: "Punarvasu",
    name_hi: "पुनर्वसु",
    number: 7,
    degree_start: 80,
    degree_end: 93.333,
    rashi: "mithun",
    ruler: "jupiter",
    deity: "Aditi",
    symbol: "Bow/quiver",
    nature: "deva",
    gana: "deva",
    quality: "movable",
    signifies: ["renewal", "return", "restoration", "abundance"],
    padas: [
      {
        pada: 1,
        syllable_en: "Ke",
        syllable_hi: "के",
        navamsha_rashi: "Mesh",
        sub_ruler: "Mars",
      },
      {
        pada: 2,
        syllable_en: "Ko",
        syllable_hi: "को",
        navamsha_rashi: "Vrishabh",
        sub_ruler: "Venus",
      },
      {
        pada: 3,
        syllable_en: "Ha",
        syllable_hi: "हा",
        navamsha_rashi: "Mithun",
        sub_ruler: "Mercury",
      },
      {
        pada: 4,
        syllable_en: "Hi",
        syllable_hi: "ही",
        navamsha_rashi: "Karka",
        sub_ruler: "Moon",
      },
    ],
    nadi: "adi",
    letters: ["Ke", "Ko", "Ha", "Hi"],
    pada_letters: ["Ke", "Ko", "Ha", "Hi"],
  },
  {
    id: "pushya",
    name_en: "Pushya",
    name_hi: "पुष्य",
    number: 8,
    degree_start: 93.333,
    degree_end: 106.667,
    rashi: "kark",
    ruler: "saturn",
    deity: "Brihaspati",
    symbol: "Flower/cow udder",
    nature: "deva",
    gana: "deva",
    quality: "light",
    signifies: ["nourishment", "protection", "dharma", "prosperity"],
    padas: [
      {
        pada: 1,
        syllable_en: "Hu",
        syllable_hi: "हू",
        navamsha_rashi: "Simha",
        sub_ruler: "Sun",
      },
      {
        pada: 2,
        syllable_en: "He",
        syllable_hi: "हे",
        navamsha_rashi: "Kanya",
        sub_ruler: "Mercury",
      },
      {
        pada: 3,
        syllable_en: "Ho",
        syllable_hi: "हो",
        navamsha_rashi: "Tula",
        sub_ruler: "Venus",
      },
      {
        pada: 4,
        syllable_en: "Da",
        syllable_hi: "ड",
        navamsha_rashi: "Vrishchik",
        sub_ruler: "Mars",
      },
    ],
    nadi: "madhya",
    letters: ["Hu", "He", "Ho", "Da"],
    pada_letters: ["Hu", "He", "Ho", "Da"],
  },
  {
    id: "ashlesha",
    name_en: "Ashlesha",
    name_hi: "आश्लेषा",
    number: 9,
    degree_start: 106.667,
    degree_end: 120,
    rashi: "kark",
    ruler: "mercury",
    deity: "Naga (serpent)",
    symbol: "Coiled serpent",
    nature: "rakshasa",
    gana: "rakshasa",
    quality: "sharp",
    signifies: ["mysticism", "kundalini", "clinging", "poison_medicine"],
    padas: [
      {
        pada: 1,
        syllable_en: "Di",
        syllable_hi: "डी",
        navamsha_rashi: "Dhanu",
        sub_ruler: "Jupiter",
      },
      {
        pada: 2,
        syllable_en: "Du",
        syllable_hi: "डू",
        navamsha_rashi: "Makar",
        sub_ruler: "Saturn",
      },
      {
        pada: 3,
        syllable_en: "De",
        syllable_hi: "डे",
        navamsha_rashi: "Kumbh",
        sub_ruler: "Saturn",
      },
      {
        pada: 4,
        syllable_en: "Do",
        syllable_hi: "डो",
        navamsha_rashi: "Meen",
        sub_ruler: "Jupiter",
      },
    ],
    nadi: "antya",
    letters: ["Di", "Du", "De", "Do"],
    pada_letters: ["Di", "Du", "De", "Do"],
  },
  {
    id: "magha",
    name_en: "Magha",
    name_hi: "मघा",
    number: 10,
    degree_start: 120,
    degree_end: 133.333,
    rashi: "singh",
    ruler: "ketu",
    deity: "Pitris (ancestors)",
    symbol: "Throne/palanquin",
    nature: "rakshasa",
    gana: "rakshasa",
    quality: "fierce",
    signifies: ["royalty", "ancestors", "authority", "tradition"],
    padas: [
      {
        pada: 1,
        syllable_en: "Ma",
        syllable_hi: "मा",
        navamsha_rashi: "Mesh",
        sub_ruler: "Mars",
      },
      {
        pada: 2,
        syllable_en: "Mi",
        syllable_hi: "मी",
        navamsha_rashi: "Vrishabh",
        sub_ruler: "Venus",
      },
      {
        pada: 3,
        syllable_en: "Mu",
        syllable_hi: "मू",
        navamsha_rashi: "Mithun",
        sub_ruler: "Mercury",
      },
      {
        pada: 4,
        syllable_en: "Me",
        syllable_hi: "मे",
        navamsha_rashi: "Karka",
        sub_ruler: "Moon",
      },
    ],
    nadi: "antya",
    letters: ["Ma", "Mi", "Mu", "Me"],
    pada_letters: ["Ma", "Mi", "Mu", "Me"],
  },
  {
    id: "purva_phalguni",
    name_en: "Purva Phalguni",
    name_hi: "पूर्व फाल्गुनी",
    number: 11,
    degree_start: 133.333,
    degree_end: 146.667,
    rashi: "singh",
    ruler: "venus",
    deity: "Bhaga",
    symbol: "Front legs of bed",
    nature: "manushya",
    gana: "manushya",
    quality: "fierce",
    signifies: ["pleasure", "relaxation", "love", "creativity"],
    padas: [
      {
        pada: 1,
        syllable_en: "Mo",
        syllable_hi: "मो",
        navamsha_rashi: "Simha",
        sub_ruler: "Sun",
      },
      {
        pada: 2,
        syllable_en: "Ta",
        syllable_hi: "टा",
        navamsha_rashi: "Kanya",
        sub_ruler: "Mercury",
      },
      {
        pada: 3,
        syllable_en: "Ti",
        syllable_hi: "टी",
        navamsha_rashi: "Tula",
        sub_ruler: "Venus",
      },
      {
        pada: 4,
        syllable_en: "Tu",
        syllable_hi: "टू",
        navamsha_rashi: "Vrishchik",
        sub_ruler: "Mars",
      },
    ],
    nadi: "madhya",
    letters: ["Mo", "Ta", "Ti", "Tu"],
    pada_letters: ["Mo", "Ta", "Ti", "Tu"],
  },
  {
    id: "uttara_phalguni",
    name_en: "Uttara Phalguni",
    name_hi: "उत्तर फाल्गुनी",
    number: 12,
    degree_start: 146.667,
    degree_end: 160,
    rashi: "singh",
    ruler: "sun",
    deity: "Aryaman",
    symbol: "Back legs of bed",
    nature: "manushya",
    gana: "manushya",
    quality: "fixed",
    signifies: ["friendship", "patronage", "contracts", "marriage"],
    padas: [
      {
        pada: 1,
        syllable_en: "Te",
        syllable_hi: "टे",
        navamsha_rashi: "Dhanu",
        sub_ruler: "Jupiter",
      },
      {
        pada: 2,
        syllable_en: "To",
        syllable_hi: "टो",
        navamsha_rashi: "Makar",
        sub_ruler: "Saturn",
      },
      {
        pada: 3,
        syllable_en: "Pa",
        syllable_hi: "पा",
        navamsha_rashi: "Kumbh",
        sub_ruler: "Saturn",
      },
      {
        pada: 4,
        syllable_en: "Pi",
        syllable_hi: "पी",
        navamsha_rashi: "Meen",
        sub_ruler: "Jupiter",
      },
    ],
    nadi: "adi",
    letters: ["Te", "To", "Pa", "Pi"],
    pada_letters: ["Te", "To", "Pa", "Pi"],
  },
  {
    id: "hasta",
    name_en: "Hasta",
    name_hi: "हस्त",
    number: 13,
    degree_start: 160,
    degree_end: 173.333,
    rashi: "kanya",
    ruler: "moon",
    deity: "Savitar",
    symbol: "Palm/hand",
    nature: "deva",
    gana: "deva",
    quality: "light",
    signifies: ["skill", "craftsmanship", "healing", "dexterity"],
    padas: [
      {
        pada: 1,
        syllable_en: "Pu",
        syllable_hi: "पू",
        navamsha_rashi: "Mesh",
        sub_ruler: "Mars",
      },
      {
        pada: 2,
        syllable_en: "Sha",
        syllable_hi: "ष",
        navamsha_rashi: "Vrishabh",
        sub_ruler: "Venus",
      },
      {
        pada: 3,
        syllable_en: "Na",
        syllable_hi: "ण",
        navamsha_rashi: "Mithun",
        sub_ruler: "Mercury",
      },
      {
        pada: 4,
        syllable_en: "Tha",
        syllable_hi: "ठ",
        navamsha_rashi: "Karka",
        sub_ruler: "Moon",
      },
    ],
    nadi: "adi",
    letters: ["Pu", "Sha", "Na", "Tha"],
    pada_letters: ["Pu", "Sha", "Na", "Tha"],
  },
  {
    id: "chitra",
    name_en: "Chitra",
    name_hi: "चित्रा",
    number: 14,
    degree_start: 173.333,
    degree_end: 186.667,
    rashi: "kanya",
    ruler: "mars",
    deity: "Vishwakarma",
    symbol: "Bright jewel/pearl",
    nature: "rakshasa",
    gana: "rakshasa",
    quality: "soft",
    signifies: ["beauty", "artistry", "architecture", "illusion"],
    padas: [
      {
        pada: 1,
        syllable_en: "Pe",
        syllable_hi: "पे",
        navamsha_rashi: "Simha",
        sub_ruler: "Sun",
      },
      {
        pada: 2,
        syllable_en: "Po",
        syllable_hi: "पो",
        navamsha_rashi: "Kanya",
        sub_ruler: "Mercury",
      },
      {
        pada: 3,
        syllable_en: "Ra",
        syllable_hi: "रा",
        navamsha_rashi: "Tula",
        sub_ruler: "Venus",
      },
      {
        pada: 4,
        syllable_en: "Ri",
        syllable_hi: "री",
        navamsha_rashi: "Vrishchik",
        sub_ruler: "Mars",
      },
    ],
    nadi: "madhya",
    letters: ["Pe", "Po", "Ra", "Ri"],
    pada_letters: ["Pe", "Po", "Ra", "Ri"],
  },
  {
    id: "swati",
    name_en: "Swati",
    name_hi: "स्वाति",
    number: 15,
    degree_start: 186.667,
    degree_end: 200,
    rashi: "tula",
    ruler: "rahu",
    deity: "Vayu",
    symbol: "Coral/young sprout",
    nature: "deva",
    gana: "deva",
    quality: "movable",
    signifies: ["independence", "flexibility", "trade", "air"],
    padas: [
      {
        pada: 1,
        syllable_en: "Ru",
        syllable_hi: "रू",
        navamsha_rashi: "Dhanu",
        sub_ruler: "Jupiter",
      },
      {
        pada: 2,
        syllable_en: "Re",
        syllable_hi: "रे",
        navamsha_rashi: "Makar",
        sub_ruler: "Saturn",
      },
      {
        pada: 3,
        syllable_en: "Ro",
        syllable_hi: "रो",
        navamsha_rashi: "Kumbh",
        sub_ruler: "Saturn",
      },
      {
        pada: 4,
        syllable_en: "Taa",
        syllable_hi: "ता",
        navamsha_rashi: "Meen",
        sub_ruler: "Jupiter",
      },
    ],
    nadi: "antya",
    letters: ["Ru", "Re", "Ro", "Taa"],
    pada_letters: ["Ru", "Re", "Ro", "Taa"],
  },
  {
    id: "vishakha",
    name_en: "Vishakha",
    name_hi: "विशाखा",
    number: 16,
    degree_start: 200,
    degree_end: 213.333,
    rashi: "tula",
    ruler: "jupiter",
    deity: "Indra-Agni",
    symbol: "Triumphal arch/potter's wheel",
    nature: "rakshasa",
    gana: "rakshasa",
    quality: "mixed",
    signifies: ["determination", "goal", "triumph", "transformation"],
    padas: [
      {
        pada: 1,
        syllable_en: "Ti",
        syllable_hi: "ती",
        navamsha_rashi: "Mesh",
        sub_ruler: "Mars",
      },
      {
        pada: 2,
        syllable_en: "Tu",
        syllable_hi: "तू",
        navamsha_rashi: "Vrishabh",
        sub_ruler: "Venus",
      },
      {
        pada: 3,
        syllable_en: "Te",
        syllable_hi: "ते",
        navamsha_rashi: "Mithun",
        sub_ruler: "Mercury",
      },
      {
        pada: 4,
        syllable_en: "To",
        syllable_hi: "तो",
        navamsha_rashi: "Karka",
        sub_ruler: "Moon",
      },
    ],
    nadi: "antya",
    letters: ["Ti", "Tu", "Te", "To"],
    pada_letters: ["Ti", "Tu", "Te", "To"],
  },
  {
    id: "anuradha",
    name_en: "Anuradha",
    name_hi: "अनुराधा",
    number: 17,
    degree_start: 213.333,
    degree_end: 226.667,
    rashi: "vrishchik",
    ruler: "saturn",
    deity: "Mitra",
    symbol: "Lotus",
    nature: "deva",
    gana: "deva",
    quality: "soft",
    signifies: ["friendship", "devotion", "success_abroad", "organization"],
    padas: [
      {
        pada: 1,
        syllable_en: "Na",
        syllable_hi: "ना",
        navamsha_rashi: "Simha",
        sub_ruler: "Sun",
      },
      {
        pada: 2,
        syllable_en: "Ni",
        syllable_hi: "नी",
        navamsha_rashi: "Kanya",
        sub_ruler: "Mercury",
      },
      {
        pada: 3,
        syllable_en: "Nu",
        syllable_hi: "नू",
        navamsha_rashi: "Tula",
        sub_ruler: "Venus",
      },
      {
        pada: 4,
        syllable_en: "Ne",
        syllable_hi: "ने",
        navamsha_rashi: "Vrishchik",
        sub_ruler: "Mars",
      },
    ],
    nadi: "madhya",
    letters: ["Na", "Ni", "Nu", "Ne"],
    pada_letters: ["Na", "Ni", "Nu", "Ne"],
  },
  {
    id: "jyeshtha",
    name_en: "Jyeshtha",
    name_hi: "ज्येष्ठा",
    number: 18,
    degree_start: 226.667,
    degree_end: 240,
    rashi: "vrishchik",
    ruler: "mercury",
    deity: "Indra",
    symbol: "Earring/umbrella",
    nature: "rakshasa",
    gana: "rakshasa",
    quality: "sharp",
    signifies: ["seniority", "protection", "authority", "occult"],
    padas: [
      {
        pada: 1,
        syllable_en: "No",
        syllable_hi: "नो",
        navamsha_rashi: "Dhanu",
        sub_ruler: "Jupiter",
      },
      {
        pada: 2,
        syllable_en: "Ya",
        syllable_hi: "या",
        navamsha_rashi: "Makar",
        sub_ruler: "Saturn",
      },
      {
        pada: 3,
        syllable_en: "Yi",
        syllable_hi: "यी",
        navamsha_rashi: "Kumbh",
        sub_ruler: "Saturn",
      },
      {
        pada: 4,
        syllable_en: "Yu",
        syllable_hi: "यू",
        navamsha_rashi: "Meen",
        sub_ruler: "Jupiter",
      },
    ],
    nadi: "adi",
    letters: ["No", "Ya", "Yi", "Yu"],
    pada_letters: ["No", "Ya", "Yi", "Yu"],
  },
  {
    id: "moola",
    name_en: "Moola",
    name_hi: "मूल",
    number: 19,
    degree_start: 240,
    degree_end: 253.333,
    rashi: "dhanu",
    ruler: "ketu",
    deity: "Nirrti",
    symbol: "Bunch of roots",
    nature: "rakshasa",
    gana: "rakshasa",
    quality: "sharp",
    signifies: ["root_cause", "destruction_creation", "research", "foundation"],
    padas: [
      {
        pada: 1,
        syllable_en: "Ye",
        syllable_hi: "ये",
        navamsha_rashi: "Mesh",
        sub_ruler: "Mars",
      },
      {
        pada: 2,
        syllable_en: "Yo",
        syllable_hi: "यो",
        navamsha_rashi: "Vrishabh",
        sub_ruler: "Venus",
      },
      {
        pada: 3,
        syllable_en: "Bha",
        syllable_hi: "भा",
        navamsha_rashi: "Mithun",
        sub_ruler: "Mercury",
      },
      {
        pada: 4,
        syllable_en: "Bhi",
        syllable_hi: "भी",
        navamsha_rashi: "Karka",
        sub_ruler: "Moon",
      },
    ],
    nadi: "adi",
    letters: ["Ye", "Yo", "Bha", "Bhi"],
    pada_letters: ["Ye", "Yo", "Bha", "Bhi"],
  },
  {
    id: "purva_ashadha",
    name_en: "Purva Ashadha",
    name_hi: "पूर्वाषाढ़ा",
    number: 20,
    degree_start: 253.333,
    degree_end: 266.667,
    rashi: "dhanu",
    ruler: "venus",
    deity: "Apas (water)",
    symbol: "Fan/elephant tusk",
    nature: "manushya",
    gana: "manushya",
    quality: "fierce",
    signifies: ["invincibility", "purification", "conviction", "early_victory"],
    padas: [
      {
        pada: 1,
        syllable_en: "Bhu",
        syllable_hi: "भू",
        navamsha_rashi: "Simha",
        sub_ruler: "Sun",
      },
      {
        pada: 2,
        syllable_en: "Dha",
        syllable_hi: "ध",
        navamsha_rashi: "Kanya",
        sub_ruler: "Mercury",
      },
      {
        pada: 3,
        syllable_en: "Pha",
        syllable_hi: "फ",
        navamsha_rashi: "Tula",
        sub_ruler: "Venus",
      },
      {
        pada: 4,
        syllable_en: "Dha",
        syllable_hi: "ढ",
        navamsha_rashi: "Vrishchik",
        sub_ruler: "Mars",
      },
    ],
    nadi: "madhya",
    letters: ["Bhu", "Dha", "Pha", "Dha"],
    pada_letters: ["Bhu", "Dha", "Pha", "Dha"],
  },
  {
    id: "uttara_ashadha",
    name_en: "Uttara Ashadha",
    name_hi: "उत्तराषाढ़ा",
    number: 21,
    degree_start: 266.667,
    degree_end: 280,
    rashi: "dhanu",
    ruler: "sun",
    deity: "Vishvadevas",
    symbol: "Elephant tusk/planks of bed",
    nature: "manushya",
    gana: "manushya",
    quality: "fixed",
    signifies: ["final_victory", "leadership", "endurance", "universal"],
    padas: [
      {
        pada: 1,
        syllable_en: "Bhe",
        syllable_hi: "भे",
        navamsha_rashi: "Dhanu",
        sub_ruler: "Jupiter",
      },
      {
        pada: 2,
        syllable_en: "Bho",
        syllable_hi: "भो",
        navamsha_rashi: "Makar",
        sub_ruler: "Saturn",
      },
      {
        pada: 3,
        syllable_en: "Ja",
        syllable_hi: "जा",
        navamsha_rashi: "Kumbh",
        sub_ruler: "Saturn",
      },
      {
        pada: 4,
        syllable_en: "Ji",
        syllable_hi: "जी",
        navamsha_rashi: "Meen",
        sub_ruler: "Jupiter",
      },
    ],
    nadi: "antya",
    letters: ["Bhe", "Bho", "Ja", "Ji"],
    pada_letters: ["Bhe", "Bho", "Ja", "Ji"],
  },
  {
    id: "shravana",
    name_en: "Shravana",
    name_hi: "श्रवण",
    number: 22,
    degree_start: 280,
    degree_end: 293.333,
    rashi: "makar",
    ruler: "moon",
    deity: "Vishnu",
    symbol: "Three footprints/ear",
    nature: "deva",
    gana: "deva",
    quality: "movable",
    signifies: ["listening", "learning", "connection", "media"],
    padas: [
      {
        pada: 1,
        syllable_en: "Ju",
        syllable_hi: "जू",
        navamsha_rashi: "Mesh",
        sub_ruler: "Mars",
      },
      {
        pada: 2,
        syllable_en: "Je",
        syllable_hi: "जे",
        navamsha_rashi: "Vrishabh",
        sub_ruler: "Venus",
      },
      {
        pada: 3,
        syllable_en: "Jo",
        syllable_hi: "जो",
        navamsha_rashi: "Mithun",
        sub_ruler: "Mercury",
      },
      {
        pada: 4,
        syllable_en: "Gha",
        syllable_hi: "घ",
        navamsha_rashi: "Karka",
        sub_ruler: "Moon",
      },
    ],
    nadi: "antya",
    letters: ["Ju", "Je", "Jo", "Gha"],
    pada_letters: ["Ju", "Je", "Jo", "Gha"],
  },
  {
    id: "dhanishta",
    name_en: "Dhanishta",
    name_hi: "धनिष्ठा",
    number: 23,
    degree_start: 293.333,
    degree_end: 306.667,
    rashi: "makar",
    ruler: "mars",
    deity: "Vasus",
    symbol: "Drum/flute",
    nature: "rakshasa",
    gana: "rakshasa",
    quality: "movable",
    signifies: ["wealth", "music", "rhythm", "fame", "abundance"],
    padas: [
      {
        pada: 1,
        syllable_en: "Ga",
        syllable_hi: "गा",
        navamsha_rashi: "Simha",
        sub_ruler: "Sun",
      },
      {
        pada: 2,
        syllable_en: "Gi",
        syllable_hi: "गी",
        navamsha_rashi: "Kanya",
        sub_ruler: "Mercury",
      },
      {
        pada: 3,
        syllable_en: "Gu",
        syllable_hi: "गू",
        navamsha_rashi: "Tula",
        sub_ruler: "Venus",
      },
      {
        pada: 4,
        syllable_en: "Ge",
        syllable_hi: "गे",
        navamsha_rashi: "Vrishchik",
        sub_ruler: "Mars",
      },
    ],
    nadi: "madhya",
    letters: ["Ga", "Gi", "Gu", "Ge"],
    pada_letters: ["Ga", "Gi", "Gu", "Ge"],
  },
  {
    id: "shatabhisha",
    name_en: "Shatabhisha",
    name_hi: "शतभिषा",
    number: 24,
    degree_start: 306.667,
    degree_end: 320,
    rashi: "kumbh",
    ruler: "rahu",
    deity: "Varuna",
    symbol: "Empty circle/100 flowers",
    nature: "rakshasa",
    gana: "rakshasa",
    quality: "movable",
    signifies: ["healing", "mysticism", "solitude", "vast_ocean"],
    padas: [
      {
        pada: 1,
        syllable_en: "Go",
        syllable_hi: "गो",
        navamsha_rashi: "Dhanu",
        sub_ruler: "Jupiter",
      },
      {
        pada: 2,
        syllable_en: "Sa",
        syllable_hi: "सा",
        navamsha_rashi: "Makar",
        sub_ruler: "Saturn",
      },
      {
        pada: 3,
        syllable_en: "Si",
        syllable_hi: "सी",
        navamsha_rashi: "Kumbh",
        sub_ruler: "Saturn",
      },
      {
        pada: 4,
        syllable_en: "Su",
        syllable_hi: "सू",
        navamsha_rashi: "Meen",
        sub_ruler: "Jupiter",
      },
    ],
    nadi: "adi",
    letters: ["Go", "Sa", "Si", "Su"],
    pada_letters: ["Go", "Sa", "Si", "Su"],
  },
  {
    id: "purva_bhadrapada",
    name_en: "Purva Bhadrapada",
    name_hi: "पूर्व भाद्रपद",
    number: 25,
    degree_start: 320,
    degree_end: 333.333,
    rashi: "kumbh",
    ruler: "jupiter",
    deity: "Aja Ekapad",
    symbol: "Front of funeral cot/sword",
    nature: "manushya",
    gana: "manushya",
    quality: "fierce",
    signifies: ["penance", "fire", "purification", "intense_transformation"],
    padas: [
      {
        pada: 1,
        syllable_en: "Se",
        syllable_hi: "से",
        navamsha_rashi: "Mesh",
        sub_ruler: "Mars",
      },
      {
        pada: 2,
        syllable_en: "So",
        syllable_hi: "सो",
        navamsha_rashi: "Vrishabh",
        sub_ruler: "Venus",
      },
      {
        pada: 3,
        syllable_en: "Da",
        syllable_hi: "दा",
        navamsha_rashi: "Mithun",
        sub_ruler: "Mercury",
      },
      {
        pada: 4,
        syllable_en: "Di",
        syllable_hi: "दी",
        navamsha_rashi: "Karka",
        sub_ruler: "Moon",
      },
    ],
    nadi: "adi",
    letters: ["Se", "So", "Da", "Di"],
    pada_letters: ["Se", "So", "Da", "Di"],
  },
  {
    id: "uttara_bhadrapada",
    name_en: "Uttara Bhadrapada",
    name_hi: "उत्तर भाद्रपद",
    number: 26,
    degree_start: 333.333,
    degree_end: 346.667,
    rashi: "meen",
    ruler: "saturn",
    deity: "Ahir Budhnya",
    symbol: "Back of funeral cot/twin",
    nature: "manushya",
    gana: "manushya",
    quality: "fixed",
    signifies: ["depth", "kundalini", "wisdom", "cosmic_serpent"],
    padas: [
      {
        pada: 1,
        syllable_en: "Du",
        syllable_hi: "दू",
        navamsha_rashi: "Simha",
        sub_ruler: "Sun",
      },
      {
        pada: 2,
        syllable_en: "Tha",
        syllable_hi: "थ",
        navamsha_rashi: "Kanya",
        sub_ruler: "Mercury",
      },
      {
        pada: 3,
        syllable_en: "Jha",
        syllable_hi: "झ",
        navamsha_rashi: "Tula",
        sub_ruler: "Venus",
      },
      {
        pada: 4,
        syllable_en: "Da",
        syllable_hi: "दे",
        navamsha_rashi: "Vrishchik",
        sub_ruler: "Mars",
      },
    ],
    nadi: "madhya",
    letters: ["Du", "Tha", "Jha", "Da"],
    pada_letters: ["Du", "Tha", "Jha", "Da"],
  },
  {
    id: "revati",
    name_en: "Revati",
    name_hi: "रेवती",
    number: 27,
    degree_start: 346.667,
    degree_end: 360,
    rashi: "meen",
    ruler: "mercury",
    deity: "Pushan",
    symbol: "Fish/drum",
    nature: "deva",
    gana: "deva",
    quality: "soft",
    signifies: ["nourishment", "travel", "protection", "completion", "wealth"],
    padas: [
      {
        pada: 1,
        syllable_en: "De",
        syllable_hi: "दे",
        navamsha_rashi: "Dhanu",
        sub_ruler: "Jupiter",
      },
      {
        pada: 2,
        syllable_en: "Do",
        syllable_hi: "दो",
        navamsha_rashi: "Makar",
        sub_ruler: "Saturn",
      },
      {
        pada: 3,
        syllable_en: "Cha",
        syllable_hi: "च",
        navamsha_rashi: "Kumbh",
        sub_ruler: "Saturn",
      },
      {
        pada: 4,
        syllable_en: "Chi",
        syllable_hi: "ची",
        navamsha_rashi: "Meen",
        sub_ruler: "Jupiter",
      },
    ],
    nadi: "antya",
    letters: ["De", "Do", "Cha", "Chi"],
    pada_letters: ["De", "Do", "Cha", "Chi"],
  },
] as const;

export const nakshatraMap: Readonly<Record<NakshatraId, Nakshatra>> = Object.fromEntries(
  nakshatras.map((n) => [n.id, n])
) as Record<NakshatraId, Nakshatra>;

const nakshatraIdSet: ReadonlySet<string> = new Set(nakshatras.map((nakshatra) => nakshatra.id));

export function isNakshatraId(value: string): value is NakshatraId {
  return nakshatraIdSet.has(value);
}

export function getNakshatra(value: string): Nakshatra | undefined {
  return isNakshatraId(value) ? nakshatraMap[value] : undefined;
}
